/* Listicle advertorial LP analytics.
 *
 * Reuses the EXISTING Meta Pixel and GA4 — it never instantiates either.
 * Every call is guarded (typeof fbq/gtag === 'function'). fbevents.js loads
 * globally, so window.fbq IS defined here; CTA clicks fire a custom event
 * (LPCTAClick via trackCustom), NOT the standard AddToCart, which is reserved
 * for real cart adds. GA4 events mirror everything as the lander-side signal.
 *
 * Config is read from <script type="application/json" id="lst-analytics-config">.
 * No external dependencies. Every listener/observer fails closed.
 */
(function () {
  'use strict';

  /* ---- Config ---------------------------------------------------------- */
  var cfg = {
    lpName: 'listicle',
    category: 'listicle_lp',
    ctaEvent: 'LPCTAClick',          // Meta event fired on CTA click
    contentIds: [],
    contentType: 'product',
    value: 0,
    currency: 'USD'
  };
  try {
    var node = document.getElementById('lst-analytics-config');
    if (node) { cfg = Object.assign(cfg, JSON.parse(node.textContent || '{}')); }
  } catch (e) { /* swallow */ }

  /* ---- Emitters -------------------------------------------------------- */
  function ga(name, params) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', name, Object.assign({ event_category: cfg.category, lp_name: cfg.lpName }, params || {}));
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: name, event_category: cfg.category, lp_name: cfg.lpName }, params || {}));
      }
    } catch (e) { /* swallow */ }
  }
  var FB_STANDARD_EVENTS = ['AddPaymentInfo','AddToCart','AddToWishlist','CompleteRegistration',
    'Contact','CustomizeProduct','Donate','FindLocation','InitiateCheckout','Lead','PageView',
    'Purchase','Schedule','Search','StartTrial','SubmitApplication','Subscribe','ViewContent'];
  function fb(event, params) {
    try {
      if (typeof window.fbq === 'function') {
        var method = FB_STANDARD_EVENTS.indexOf(event) === -1 ? 'trackCustom' : 'track';
        window.fbq(method, event, params || {});
      }
    } catch (e) { /* swallow */ }
  }

  function getUtms() {
    var out = {};
    try {
      var p = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        var v = p.get(k);
        if (v) out[k] = v.slice(0, 100);
      });
    } catch (e) { /* swallow */ }
    return out;
  }

  function init() {
    /* 1. Page view + ViewContent --------------------------------------- */
    ga('lp_view', Object.assign({ event_label: cfg.lpName }, getUtms()));
    var vc = { content_ids: cfg.contentIds, content_type: cfg.contentType, value: cfg.value, currency: cfg.currency };
    fb('ViewContent', vc);
    ga('view_content', {
      event_label: cfg.lpName,
      currency: cfg.currency,
      value: cfg.value,
      items: [{ item_id: (cfg.contentIds[0] || ''), price: cfg.value }]
    });

    /* 2. Scroll depth 25/50/75/100 ------------------------------------- */
    var depthFired = { 25: false, 50: false, 75: false, 100: false };
    var thresholds = [25, 50, 75, 100];
    var scheduled = false;
    function onScroll() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        var doc = document.documentElement;
        var scrollable = Math.max(1, (doc.scrollHeight || 0) - (window.innerHeight || 0));
        var pct = ((window.scrollY || window.pageYOffset || 0) / scrollable) * 100;
        for (var i = 0; i < thresholds.length; i++) {
          var t = thresholds[i];
          if (!depthFired[t] && pct >= t) {
            depthFired[t] = true;
            ga('scroll_depth_' + t, { event_label: String(t), depth_pct: t });
          }
        }
        if (depthFired[100]) { window.removeEventListener('scroll', onScroll); }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* 3. Time on page -------------------------------------------------- */
    [30, 60, 120].forEach(function (sec) {
      window.setTimeout(function () {
        ga('time_on_page_' + sec + 's', { event_label: String(sec), seconds: sec });
      }, sec * 1000);
    });

    /* 3b. Reading progress bar ----------------------------------------- */
    var progressFill = document.querySelector('[data-lst-progress]');
    if (progressFill) {
      var progStartEl = document.querySelector('.lst-article');
      /* Treat the final buy box (#2) as 100% — not the citations below it. */
      var progEndEl = document.querySelector('.lst-offer--final') || document.querySelector('.lst-refs') || progStartEl;
      var progScheduled = false;
      function updateProgress() {
        if (progScheduled) return;
        progScheduled = true;
        window.requestAnimationFrame(function () {
          progScheduled = false;
          try {
            if (!progStartEl) return;
            var vh = window.innerHeight || document.documentElement.clientHeight;
            var y = window.scrollY || window.pageYOffset || 0;
            var start = progStartEl.getBoundingClientRect().top + y;
            var end = progEndEl.getBoundingClientRect().bottom + y - vh;
            var pct = end > start ? (y - start) / (end - start) : 0;
            pct = Math.max(0, Math.min(1, pct));
            progressFill.style.width = (pct * 100).toFixed(1) + '%';
          } catch (e) { /* swallow */ }
        });
      }
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    /* 4. CTA clicks: LPCTAClick (custom Meta event) + GA4, by position - */
    /* Matches the in-article CTAs ([data-track="cta"]) and the shared
       lp-sticky-cta component's button (.lp-sticky-cta__cta). */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var el = e.target.closest('[data-track="cta"]');
      var position, variantId = '';
      if (el) {
        position = el.getAttribute('data-cta-position') || 'unknown';
        variantId = el.getAttribute('data-variant-id') || '';
      } else if (e.target.closest('.lp-sticky-cta__cta')) {
        position = 'sticky';
      } else {
        return;
      }
      fb(cfg.ctaEvent, {
        content_ids: cfg.contentIds,
        content_type: cfg.contentType,
        value: cfg.value,
        currency: cfg.currency
      });
      ga('lp_cta_click', {
        event_label: position,
        cta_position: position,
        currency: cfg.currency,
        value: cfg.value,
        variant_id: variantId,
        items: [{ item_id: (cfg.contentIds[0] || ''), price: cfg.value }]
      });
      /* Distinct event per placement so CTA performance is comparable. */
      ga('cta_click_' + position.replace(/[^a-z0-9]+/gi, '_'), { event_label: position, cta_position: position });
    });

    /* 5. Smooth-scroll for in-page citation anchors -------------------- */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#lst-"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) { history.replaceState(null, '', '#' + id); }
    });

    /* 7. Section-in-view: testimonial, first CTA ----------------------- */
    if (typeof IntersectionObserver !== 'function') return;
    var seen = {};
    function observeOnce(el, name, label) {
      if (!el || seen[name]) return;
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting && !seen[name]) {
            seen[name] = true;
            ga(name, { event_label: label });
            io.disconnect();
            break;
          }
        }
      }, { threshold: 0.25 });
      io.observe(el);
    }
    observeOnce(document.querySelector('.lst-quote'), 'testimonial_view', 'testimonial');
    observeOnce(document.querySelector('.lst-offer'), 'offer_view', 'post_tip_4');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
